module.exports = __webpack_public_path__ + "img/2025_0.6ec8b942.webp";